import React, { Component } from 'react';

export default class NavBar extends Component {

    constructor (props) {
        let state = {
            navText: "Sewing Translator"
        };
        super(props);
        if (this.props.navText){
            state.navText = this.props.navText;
        }
        this.state = state;
    }

    render(){
        return (
                <nav className="navbar navbar-liesl">
                    <div className="container">
                        <h1><a href="/">
                            {this.state.navText}
                        </a></h1>
                    </div>
                </nav>
        );
    }
}

NavBar.propTypes = {
    navText:     React.PropTypes.string
};




/** WEBPACK FOOTER **
 ** ./src/components/NavBar.js
 **/